<template>
  <div class="example">
    <apexcharts height="250" type="line" :options="chartOptions" :series="series"></apexcharts>
  </div>
</template>

<script>
import { dateTimeToSlashFormat } from "@/app/shared/utils/dates";

import VueApexCharts from "vue3-apexcharts";

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  props: {
    data: { required: true, type: Object },
  },
  data() {
    return {
      selection: "one_year",
    };
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          id: "line-date",
          type: "line",
          height: 350,
          toolbar: {
            show: false,
          },
        },

        colors: ["#FFBB96", "#B7EB8F", "#87E8DE"],
        markers: {
          size: 0,
          style: "hollow",
        },
        xaxis: {
          categories: this.categories,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return parseInt(val) || 0;
            },
          },
        },
        legend: {
          position: "top",
        },
      };
    },
    categories() {
      return this.data?.tickets_states.map((value) =>
        value.date ? dateTimeToSlashFormat(value.date, false) : value.hour + ":00hrs"
      );
    },
    series() {
      return [
        {
          name: "En cola",
          data: this.data?.tickets_states.map((summary) => this.formatAxisData(summary, "EN COLA")),
        },
        {
          name: "Asignado",
          data: this.data.tickets_states.map((summary) => this.formatAxisData(summary, "ASGINADO")),
        },
        {
          name: "Resuelto",
          data: this.data.tickets_states.map((summary) => this.formatAxisData(summary, "RESUELTO")),
        },
      ];
    },
  },
  methods: {
    formatAxisData(summary, ticketState) {
      const dataArray = summary.data
        .map((state) => (state.state === ticketState ? state.count : 0))
        .filter((val) => Boolean(val));

      return dataArray.length === 0 ? 0 : dataArray[0];
    },
  },
};
</script>
